<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <!-- <ion-title>Documents</ion-title> -->
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Documents</h1>
                    <p class="auth-subtext"></p>
                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
                </div>
            </div>
            <div class="settings_menu">
                <!-- <el-button
                type="transparent"
                class="menu_item"
                @click="links.documents"
            >
                <span class="locumate_icons locumate_icon-files-empty"></span>
                <div class="text_wrapper">
                <div class="main_text">AHPRA Registration</div>
                <div class="additional_text">Manage your Documents</div>
                </div>
            </el-button> -->
                <!-- <el-button
                type="transparent"
                class="menu_item"
                @click="links.goToCovidCert"
            >
                <span class="locumate_icons locumate_icon-files-empty"></span>
                <div class="text_wrapper">
                <div class="main_text">Covid Certificate</div>
                <div class="additional_text">Manage your Documents</div>
                </div>
            </el-button> -->
                <el-button type="transparent" class="menu_item" @click="links.goToPersonalCovidCert" v-if="isAustralia">
                    <span class="locumate_icons locumate_icon-files-empty"></span>
                    <div class="text_wrapper">
                        <div class="main_text">Professional Certificates</div>
                        <div class="additional_text">Manage your Documents</div>
                    </div>
                </el-button>
                <el-button type="transparent" class="menu_item" @click="links.identityDocuments" v-if="isAustralia">
                    <span class="locumate_icons locumate_icon-files-empty"></span>
                    <div class="text_wrapper">
                        <div class="main_text">Identity Documents</div>
                        <div class="additional_text">Manage your Documents</div>
                         <span v-if="!identityDocument && user.isInternalLocum && user.locum_type != '5'"
                class="additional_text additional_text--required" v-text="'Required to become a full locum'" />
                    </div>
                </el-button>
                <el-button type="transparent" class="menu_item" @click="links.insuranceDocuments" v-if="isAustralia">
                    <span class="locumate_icons locumate_icon-files-empty"></span>
                    <div class="text_wrapper">
                        <div class="main_text">Insurance Documents</div>
                        <div class="additional_text">Manage your Documents</div>
                         <span v-if="!insuranceDocument && !otherInsuranceDocument && user.isInternalLocum && user.locum_type != '5'"
                class="additional_text additional_text--required" v-text="'Required to become a full locum'" />
                    </div>
                </el-button>
                <el-button type="transparent" class="menu_item" @click="links.cv">
                    <span class="locumate_icons locumate_icon-files-empty"></span>
                    <div class="text_wrapper">
                        <div class="main_text">CV</div>
                        <div class="additional_text">Manage your CV</div>
                         <span v-if="!locumCvs"
                class="additional_text additional_text--required" v-text="'Required to apply to shifts'" />
                    </div>
                </el-button>
            </div>
            <div class="bg-overlay"></div>
        </div>
    </div>
    <div class="background-circles">
        <div class="circle circle-2"></div>
        <div class="circle circle-1"></div>
        <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
    </div>
</template>


<script>
import { onMounted, inject, computed } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
    "arrow-back-outline": arrowBackOutline,
});
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from "@ionic/vue";

import { useStore } from "vuex";
import { useRouter } from "vue-router";
import SvgIcon from '@/components/Svg/SvgIcon.vue';
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import { checkDocs } from "@/utils/userDocs";

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon
    },
    directives: {},
    setup() {
        const $store = useStore();
        const $router = useRouter();
        const setPageClassGlobal = inject(["setPageClassGlobal"]);

        const user = $store.getters.GET_USER_DATA;
        const docsComplete = computed(() => checkDocs(user));
        const isAustralia = isAustraliaRegion();
        const covidCertPro = computed(()=>  checkDocs(user, "covidCertPro"))
        const identityDocument = computed(()=>  checkDocs(user, "identityDocument"))
        const insuranceDocument = computed(()=>  checkDocs(user, "insuranceDocument"))
        const otherInsuranceDocument = computed(()=>  checkDocs(user,"otherInsuranceDocument"))
        const locumCvs = computed(()=>  checkDocs(user,"locumCvs"))

        const links = {
            identityDocuments: () => {
                $router.push({
                    name: "profile_identity_documents",
                });
            },
            goToPersonalCovidCert: () => {
                $router.push({
                    name: "profile_personal_cert",
                });
            },
            goToCovidCert: () => {
                $router.push({
                    name: "profile_covid_cert",
                });
            },
            insuranceDocuments: () => {
                $router.push({
                    name: "profile_insurance_documents",
                });
            },

            cv: () => {
                $router.push({
                    name: "profile_cv",
                });
            },
        };

        const goBack = () => {
            $router.push({
                name: "profile",
            });
        };

        onMounted(() => {
            setPageClassGlobal("global_profile_page");
        });

        return {
            user,
            goBack,
            links,
            isAustralia,
            docsComplete,
            covidCertPro,
            identityDocument,
            insuranceDocument,
            otherInsuranceDocument,
            locumCvs,
        };
    },
};
</script>